import script from "./CurrencyInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&setup=true&lang=ts"

import "./CurrencyInput.vue?vue&type=style&index=0&id=a9a80ee2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9a80ee2"]])

export default __exports__